import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.css']
})
export class CounterComponent implements OnInit {
    counterKeyno;

    public lastNumberButtons: FormButton[] = [
        { id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.edit!.lastnumber = 0 as number },
        { id: 'calculator', icon: 'fa fa-calculator', type: 'primary', onClick: () => this.openCalculator('lastnumber') },
        { id: 'previous', icon: 'fa fa-minus', type: 'primary', onClick: () => this.edit!.lastnumber-- as number },
        { id: 'next', icon: 'fa fa-plus', type: 'primary', onClick: () => this.edit!.lastnumber++ as number }
    ];

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.counterKeyno = this.stateService.getStateParams()['counter_keyno'];
    }

    private async loadEdit() {
        if (!!this.counterKeyno) {
            this.edit = (await this.datatask.Post(2555, { counter_keyno: this.counterKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2556, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });

                    this.loadEdit();
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async openCalculator(id: string | number) {
        if (!this.edit) return;

        switch (id) {
            case 'lastnumber':
                if (id === 'lastnumber') {
                    const value = await this.modal.showCalculator(this.edit.lastnumber);

                    this.edit.lastnumber = value;
                }
                break;
            default:
                break;
        };
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    counter_id: string;
    lastnumber: any;
    stepnumber: string | number;
    grabnumber: string | number;
    counter_keyno: string;
    lastnumber_original: string;
}
